module.exports = __webpack_public_path__ + "img/10.83518a53.png";